<h2 mat-dialog-title class="tt-secondary-background" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container" cdkDragHandle style="color: white">
    <span style="width: 100%; display: inline-flex; justify-content: space-between; align-items: center">
        <span ttTranslateWord="cuttingplans_change_component_heading"></span>
        <div style="display: flex; align-items: center">
            <button style="background: transparent; border: none; margin: none; outline: none; padding: none; color: white" (click)="dialogRef.close()"><span class="far fa-times"></span></button>
        </div>
    </span>
</h2>
<mat-dialog-content>
    <tt-input ttLabel="prod_id" [ttModel]="prodId" ttReadonly></tt-input>
    <tt-search ttLabel="prod_name" [(ttModel)]="prodName" [ttSearch]="searchProducts" (ttOnSelected)="onSelected($event)" (ttOnClear)="onSelected()"></tt-search>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <tt-button-save (ttClick)="save()" [ttDisabled]="!prodId"></tt-button-save>
</mat-dialog-actions>
